import React from 'react';
import { cn } from '../../utils';
import StatsCard from './StatsCard';

const StatsGrid = ({ 
  stats = [], 
  columns = 4,
  className = '',
  ...props 
}) => {
  const gridCols = {
    1: 'grid-cols-1',
    2: 'grid-cols-1 md:grid-cols-2',
    3: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
    4: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4',
    5: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5',
    6: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6'
  };

  return (
    <div 
      className={cn(
        'grid gap-6',
        gridCols[columns] || gridCols[4],
        className
      )}
      {...props}
    >
      {stats.map((stat, index) => (
        <StatsCard
          key={stat.key || index}
          title={stat.title}
          value={stat.value}
          icon={stat.icon}
          variant={stat.variant || 'default'}
          className={stat.className}
          onClick={stat.onClick}
          role={stat.onClick ? 'button' : undefined}
          tabIndex={stat.onClick ? 0 : undefined}
          onKeyDown={
            stat.onClick
              ? (e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    stat.onClick();
                  }
                }
              : undefined
          }
        />
      ))}
    </div>
  );
};

export default StatsGrid;
